import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';

import * as api from '../../stores/api';
import store from './store';

@observer
class DashboardHeader extends React.Component {
  componentDidMount() {
    try {
      setInterval(async () => {
        store.fetchAdminData();
      }, 300000);
    } catch (e) {
    }
  }

  render() {
    const { bookingCount, statistics, todayCount, tomorrowCount, dataTarget } = store;
    const isAdmin = api.isAdminOrMagStaffOrAccounting();

    return (
      <div className="dashboard-header">
        <div className="dashboard-header-left">
          <div className="statistics statistics-inline">
            <span className="statistics-title">Today's Appointments:</span>
            <span className="statistics-count">{todayCount}</span>
            <span className="statistics-title">, Tomorrow's Appoinments:</span>
            <span className="statistics-count">{tomorrowCount}</span>
          </div>
          {isAdmin && (
            <React.Fragment>
              <div className="statistics">
                <span className="statistics-title">
                  Daily Assessments Target:
                </span>
                <span className="statistics-count">
                  {
                    dataTarget.itemList
                      .filter(i => i.Key === 'dailybookingtarget')
                      .map(i => i.Target)[0]
                  }
                </span>
              </div>
              <div className="statistics">
                <span className="statistics-title">My Today Bookings:</span>
                <span className="statistics-count">{bookingCount}</span>
              </div>
            </React.Fragment>
          )}
        </div>
        <div className="dashboard-header-right">
          <h4 className="statistics-group-title">
            {isAdmin && "Today's Total Bookings:"}{' '}
            {moment().format('dddd, DD MMM YYYY')}
          </h4>
          {isAdmin && (
            <React.Fragment>
              <div className="statistics-group">
                <div className="statistics">
                  <span className="statistics-title">IME In-person:</span>
                  <span className="statistics-count">{statistics.aCount}</span>
                </div>
                <div className="statistics">
                  <span className="statistics-title">IME Video:</span>
                  <span className="statistics-count">{statistics.vaCount}</span>
                </div>
                <div className="statistics">
                  <span className="statistics-title">Supp Reports:</span>
                  <span className="statistics-count">{statistics.sCount}</span>
                </div>
                <div className="statistics">
                  <span className="statistics-title">File Reviews:</span>
                  <span className="statistics-count">{statistics.fCount}</span>
                </div>
              </div>
              <div className="statistics-group">
                {/* <div className="statistics">
                  <span className="statistics-title">CR Retrievals:</span>
                  <span className="statistics-count">{statistics.cnCount}</span>
                </div>
                <div className="statistics">
                  <span className="statistics-title">Imaging:</span>
                  <span className="statistics-count">
                    {statistics.mriCount}
                  </span>
                </div>
                <div className="statistics">
                  <span className="statistics-title">FI:</span>
                  <span className="statistics-count">{statistics.fiCount}</span>
                </div> */}
                <div className="statistics">
                  <span className="statistics-title">Med Neg:</span>
                  <span className="statistics-count">{statistics.mnCount}</span>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default DashboardHeader;